module.exports = __webpack_public_path__ + "static/img/best_cinematography_01.cb61f35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/best_cinematography_01.jpg
// module id = 200
// module chunks = 0